
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video-testimonials",
      function () {
        return require("private-next-pages/video-testimonials/index.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video-testimonials"])
      });
    }
  